module.exports = __webpack_public_path__ + "img/p.453a4605.jpg";